export default {
  all: () => ['error_notification'],
}
